var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.7841 45.7502H27.5845C24.6029 45.7502 22.1777 43.268 22.1777 40.2185V35.941C22.1777 32.8915 24.6029 30.4092 27.5845 30.4092H51.7835C54.7651 30.4092 57.1922 32.8915 57.1922 35.941V40.2185C57.1922 43.268 54.7651 45.7502 51.7841 45.7502ZM27.5845 33.294C26.1583 33.294 24.9977 34.4822 24.9977 35.9416V40.2191C24.9977 41.6778 26.1583 42.8667 27.5845 42.8667H51.7835C53.2098 42.8667 54.3722 41.6785 54.3722 40.2191V35.9416C54.3722 34.4829 53.2104 33.294 51.7835 33.294H27.5845Z",
    fill: "#66BB6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3726 40.0965C31.4607 40.0965 32.3428 39.1943 32.3428 38.0815C32.3428 36.9686 31.4607 36.0664 30.3726 36.0664C29.2844 36.0664 28.4023 36.9686 28.4023 38.0815C28.4023 39.1943 29.2844 40.0965 30.3726 40.0965Z",
    fill: "#66BB6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3423 40.0965C37.4304 40.0965 38.3125 39.1943 38.3125 38.0815C38.3125 36.9686 37.4304 36.0664 36.3423 36.0664C35.2542 36.0664 34.3721 36.9686 34.3721 38.0815C34.3721 39.1943 35.2542 40.0965 36.3423 40.0965Z",
    fill: "#66BB6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3103 40.0961C43.3991 40.0961 44.2818 39.1934 44.2818 38.0798C44.2818 36.9662 43.3991 36.0635 42.3103 36.0635C41.2215 36.0635 40.3389 36.9662 40.3389 38.0798C40.3389 39.1934 41.2215 40.0961 42.3103 40.0961Z",
    fill: "#66BB6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.281 36.0674C49.3677 36.0674 50.2494 36.9685 50.2494 38.0805C50.2494 39.1938 49.3683 40.0968 48.281 40.0968C47.1907 40.0968 46.3096 39.1938 46.3096 38.0805C46.3089 36.9685 47.1907 36.0674 48.281 36.0674Z",
    fill: "#66BB6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6448 21.4464C29.8665 21.4464 29.2348 20.8003 29.2348 20.0043V13.6278C29.2348 10.734 26.9344 8.38121 24.105 8.38121C21.2757 8.38121 18.9752 10.734 18.9752 13.6278V20.0043C18.9752 20.8003 18.3436 21.4464 17.5652 21.4464C16.7869 21.4464 16.1553 20.8003 16.1553 20.0043V13.6278C16.1553 9.1439 19.7203 5.49707 24.105 5.49707C28.4897 5.49707 32.0548 9.14326 32.0548 13.6278V20.0043C32.0548 20.801 31.4231 21.4464 30.6448 21.4464Z",
    fill: "#66BB6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4541 39.9991H16.4248C14.1833 39.9991 12.3604 38.1327 12.3604 35.8382V22.7487C12.3604 20.4542 14.1833 18.5879 16.4248 18.5879H32.6139C34.8554 18.5879 36.6784 20.4542 36.6784 22.7487V30.07C36.6784 30.866 36.0467 31.512 35.2684 31.512C34.4901 31.512 33.8584 30.866 33.8584 30.07V22.7487C33.8584 22.0444 33.3001 21.472 32.6139 21.472H16.4248C15.738 21.472 15.1803 22.045 15.1803 22.7487V35.8382C15.1803 36.5426 15.7387 37.115 16.4248 37.115H19.4541C20.2324 37.115 20.8641 37.761 20.8641 38.557C20.8641 39.353 20.2324 39.9991 19.4541 39.9991Z",
    fill: "#66BB6A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 90.8197,
    height: 92.8869,
    fill: "white",
    transform: "translate(0.442383 0.713867) scale(0.69)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.46015d664f1a3387887a67e35d683576.svg";
export { ForwardRef as ReactComponent };